import React from 'react';
import PropTypes from 'prop-types';
import AttendeeList from './attendee-list';
import AttendeeListCompact from './attendee-list-compact';
import { isEmpty } from 'lodash';
import { FormattedMessage } from 'react-intl';

export const AttendeeDetailsSection = ({
  isUserGuest = false,
  isAttendeesEmpty = false,
  isAttendeesAndPendingEmpty = false,
  hasUserRSVP = false,
  attendees = [],
  pendingAttendees = [],
  isLoggedIn = false,
  redirectLocation = ''
}) => {
  if (isUserGuest && isAttendeesAndPendingEmpty) {
    return (
      <div className="margin-md-top" data-testing-id="no-attendees-msg">
        <FormattedMessage id="invite.attendee_details_section.no_rsvp" defaultMessage="No one has RSVP’d yet. Share your invite with guests to give them access to your event details." />
      </div>
    );
  }

  if ((isUserGuest && !isAttendeesAndPendingEmpty) || hasUserRSVP) {
    return <AttendeeList attendees={attendees} pendingAttendees={pendingAttendees} isUserGuest={isUserGuest} />;
  }

  if (!isAttendeesEmpty) {
    return <AttendeeListCompact attendees={attendees} redirectLocation={redirectLocation} showRsvpText isLoggedIn={isLoggedIn} hasUserRSVP={hasUserRSVP}/>;
  }

  return null;
};

const GuestList = ({
  attendees = [],
  pendingAttendees = [],
  isUserGuest = false,
  hasUserRSVP = false,
  redirectToShare = null,
  handleAcceptInvitation = null,
  handleDeclineInvitation = null,
  isLoggedIn = false,
  redirectLocation = ''
}) => {
  const isAttendeesEmpty = isEmpty(attendees);
  const isPendingEmpty = isEmpty(pendingAttendees);
  const isAttendeesAndPendingEmpty = isAttendeesEmpty && isPendingEmpty;

  return (
    <div className="GuestList">
      <AttendeeDetailsSection
        isUserGuest={isUserGuest}
        isAttendeesEmpty={isAttendeesEmpty}
        isAttendeesAndPendingEmpty={isAttendeesAndPendingEmpty}
        hasUserRSVP={hasUserRSVP}
        attendees={attendees}
        pendingAttendees={pendingAttendees}
        isLoggedIn={isLoggedIn}
        redirectLocation={redirectLocation}
      />

      { !hasUserRSVP && !isUserGuest &&
        <div className="guest-list-rsvp-buttons" data-testing-id="invitation-block">
          <div className="accept">
            <button className="accept-btn btn btn-primary" onClick={handleAcceptInvitation} data-testing-id="accept-invitation-btn">
              <FormattedMessage id="invite.guest_list.accept_invitation" defaultMessage='Accept Invitation' />
            </button>
          </div>

          <div className="decline">
            <button className="decline-btn btn btn-outlined-light" onClick={handleDeclineInvitation} data-testing-id="decline-invitation-btn">
              <FormattedMessage id="invite.guest_list.decline_invitation" defaultMessage='Decline' />
            </button>
          </div>
        </div>
      }

      { isUserGuest &&
        <button className="accept-btn btn btn-primary margin-xxl-top" onClick={redirectToShare} data-testing-id="share-invitation-btn">
          <FormattedMessage id="invite.guest_list.share_invite" defaultMessage='Share Invite' />
        </button>
      }
    </div>
  );
};

GuestList.propTypes = {
  attendees: PropTypes.array,
  pendingAttendees: PropTypes.array,
  isUserGuest: PropTypes.bool,
  hasUserRSVP: PropTypes.bool,
  redirectToShare: PropTypes.func,
  handleAcceptInvitation: PropTypes.func,
  handleDeclineInvitation: PropTypes.func
};

export default GuestList;
